import { render } from "./ReadOnly.vue?vue&type=template&id=40fe80ce&scoped=true"
import script from "./ReadOnly.vue?vue&type=script&lang=js"
export * from "./ReadOnly.vue?vue&type=script&lang=js"

import "./ReadOnly.vue?vue&type=style&index=0&id=40fe80ce&scoped=true&lang=css"

import exportComponent from "/home/pslcal/di-di.biz/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fe80ce"]])

export default __exports__